import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("canvas", { id: "image_canvas" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("canvas", { id: "d2_canvas" }, null, -1)
const _hoisted_3 = { id: "container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_HeatmapsViewer = _resolveComponent("HeatmapsViewer")!
  const _component_HeatmapsPanel = _resolveComponent("HeatmapsPanel")!
  const _component_HeatmapLegendQuantification = _resolveComponent("HeatmapLegendQuantification")!
  const _component_HeatmapsLegend = _resolveComponent("HeatmapsLegend")!
  const _component_Cases = _resolveComponent("Cases")!
  const _component_SlideList = _resolveComponent("SlideList")!
  const _component_ViewerTools = _resolveComponent("ViewerTools")!
  const _component_AlertsPanel = _resolveComponent("AlertsPanel")!
  const _component_Gallery = _resolveComponent("Gallery")!
  const _component_CaseDiagnosisForm = _resolveComponent("CaseDiagnosisForm")!
  const _component_StatisticsScreen = _resolveComponent("StatisticsScreen")!
  const _component_CaseReport = _resolveComponent("CaseReport")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_i_dialog = _resolveComponent("i-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AppHeader),
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_HeatmapsViewer),
    _withDirectives(_createVNode(_component_HeatmapsPanel, null, null, 512), [
      [_vShow, _ctx.currentSlide?.id]
    ]),
    (_ctx.currentSlide?.id && _ctx.isQuantificationLegend && _ctx.isVisible)
      ? (_openBlock(), _createBlock(_component_HeatmapLegendQuantification, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(_component_HeatmapsLegend, null, null, 512), [
        [_vShow, _ctx.currentSlide?.id && _ctx.isVisible]
      ]),
      _createVNode(_component_Cases),
      (_ctx.activeCase)
        ? (_openBlock(), _createBlock(_component_SlideList, { key: 0 }))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_ViewerTools, null, null, 512), [
        [_vShow, _ctx.currentSlide?.id]
      ]),
      _createVNode(_component_AlertsPanel),
      (_ctx.isFirstRead && _ctx.currentSlide?.id)
        ? (_openBlock(), _createBlock(_component_Gallery, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_CaseDiagnosisForm),
    (_ctx.isStatisticsScreenDisplayed && _ctx.config.enable_statistics)
      ? (_openBlock(), _createBlock(_component_StatisticsScreen, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.isFirstRead && _ctx.isCaseReportDisplayed)
      ? (_openBlock(), _createBlock(_component_CaseReport, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.isError && _ctx.config.block_usage_on_error)
      ? (_openBlock(), _createBlock(_component_i_dialog, {
          key: 3,
          title: _ctx.t('server_error_modal.title'),
          type: _ctx.modalTypes.ERROR,
          closeIcon: false
        }, {
          body: _withCtx(() => [
            _createVNode(_component_i18n_t, {
              tag: "p",
              keypath: "server_error_modal.body"
            }, {
              newline: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "type"]))
      : _createCommentVNode("", true)
  ]))
}